var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.3076,
    y: 40.7949,
    width: 55.0256,
    height: 55.0256,
    fill: "#6692EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7315 95.8836H68.791H63.96H62.9166V71.8193H70.7869C72.7828 71.8193 73.9622 69.5512 72.7828 67.9182L57.4732 46.7343C56.498 45.3734 54.4794 45.3734 53.5041 46.7343L38.1945 67.9182C37.0151 69.5512 38.1718 71.8193 40.1904 71.8193H48.0607V95.8836H47.0174H42.1864H21.388C9.48059 95.2259 0 84.0896 0 72.0234C0 63.6995 4.51349 56.4417 11.2043 52.5179C10.5919 50.8622 10.2744 49.0931 10.2744 47.2332C10.2744 38.7279 17.1467 31.8556 25.652 31.8556C27.4892 31.8556 29.2583 32.1732 30.914 32.7856C35.8357 22.3524 46.4504 15.1172 58.7887 15.1172C74.756 15.1399 87.9109 27.3648 89.4079 42.9466C101.678 45.0559 111 56.419 111 69.279C111 83.0236 100.295 94.931 86.7315 95.8836Z",
    fill: "#021948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadExcelIcon);
export default __webpack_public_path__ + "static/media/uploadExcelIcon.b1563e331ef25e2dba80932591860a29.svg";
export { ForwardRef as ReactComponent };